import {Modal} from "antd";
import {useState} from "react";
import CalendarModal from "./CalendarModal";
import {t} from "i18next";
const CalendarModalParent = ({visible, onCancel, onSubmit,objectParam}) => {

    const [destroy, setDestroy] = useState(false)
    return (
        <Modal open={visible}
               width={990}
               onCancel={() => {
                   setDestroy(true)
               }}
               title={ t("tnp.components.report.customReport")}
               bodyStyle={{
                   minHeight: 100,
                   maxHeight: 480,
                   height: 510,
                   overflowY: "hidden",
                   overflowX: "hidden",
               }}
               className="modalStyle modalStyleParent "
               destroyOnClose={true}
               footer={null}>
            <CalendarModal onCancel={onCancel}
                           destroy={destroy}
                           onDestroy={() => setDestroy(false)}
                           onSubmit={onSubmit}
                           objectParam={objectParam}/>
        </Modal>
    )
}
export default CalendarModalParent
